var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.083,
    height: 15.053,
    viewBox: "0 0 15.083 15.053",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-solid",
    transform: "translate(-12.112 -9.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M13.026,46.852,12.134,50.7a.966.966,0,0,0,.938,1.173,1,1,0,0,0,.2,0l3.869-.891,7.429-7.4-4.146-4.137Z",
    transform: "translate(0 -27.137)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    d: "M121.443,12.737l-2.767-2.767a.971.971,0,0,0-1.37,0l-1.538,1.538,4.141,4.141,1.538-1.538a.971.971,0,0,0,0-1.374Z",
    transform: "translate(-94.534)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNode);
export default __webpack_public_path__ + "static/media/edit_node.c64f2fdf35844140fb0dd223c9636c8e.svg";
export { ForwardRef as ReactComponent };